import type { MessageDescriptor } from 'react-intl';

export const NEW_ENTITY: MessageDescriptor = { id: 'common.breadcrumb.newEntity', defaultMessage: 'New {entity}' };
export const UPDATE_ENTITY: MessageDescriptor = { id: 'common.breadcrumb.updateEntity', defaultMessage: 'Update {entity}' };

export const TITLE_ENTITY = {
  DEALER_MANAGEMENT: { id: 'page.config.management.dashboard.title', defaultMessage: 'Dealership management' },
  GROUP_MANAGEMENT: { id: 'group_config.dashboard.title', defaultMessage: 'Group management' },
  CCM: { id: 'ccm.card.label', defaultMessage: 'Customer communication' },
  MODELS: { id: 'models', defaultMessage: 'Models' },
  USER_GROUPS: { id: 'userGroups.title', defaultMessage: 'User groups' },
  DEVICES: { id: 'devices', defaultMessage: 'Devices' },
  WHITELIST: { id: 'page.config.whitelist.title', defaultMessage: 'Whitelist' },
  HARDWARES: { id: 'hardware.title', defaultMessage: 'Hardware' },
  SAFES: { id: 'page.config.dealer_general.safes.page.title', defaultMessage: 'Safes' },
  MEDIA_LIBRARY: { id: 'mediaLibrary.title', defaultMessage: 'Media library' },
  PUBLIC_TOKENS: { id: 'publicTokens', defaultMessage: 'Public tokens' },
  SMS_ACCOUNTS: { id: 'page.smsAccounts.title', defaultMessage: 'SMS accounts' },
  TEMPLATES: { id: 'templates', defaultMessage: 'Templates' },

  USERS: { id: 'users', defaultMessage: 'Users' },
  USER: { id: 'common.entity.user', defaultMessage: 'user' },

  PAYERS: { id: 'payers', defaultMessage: 'Payers' },
  PAYER: { id: 'common.entity.payer', defaultMessage: 'payer' },

  KIOSKS: { id: 'page.kiosks.entities', defaultMessage: 'Kiosks' },
  KIOSK: { id: 'common.entity.kiosk', defaultMessage: 'kiosk' },

  CAMERAS: { id: 'camera.title', defaultMessage: 'Camera' },
  CAMERA: { id: 'common.entity.camera', defaultMessage: 'camera' },

  AUDIT_MODELS: { id: 'auditTemplates', defaultMessage: 'Audit templates' },
  AUDIT_MODEL: { id: 'common.entity.auditModel', defaultMessage: 'audit template' },

  CHECKLISTS: { id: 'checklists', defaultMessage: 'Checklists' },
  CHECKLIST: { id: 'common.entity.checklist', defaultMessage: 'checklist' },

  GUIDELINES: { id: 'page.fiche.guidelines.dashboard.title', defaultMessage: 'Guidelines' },
  GUIDELINE: { id: 'common.entity.guideline', defaultMessage: 'guideline' },

  PREDEFINED_MESSAGES: { id: 'page.config.dealer_general.predefined_messages.title', defaultMessage: 'Predefined messages', },
  PREDEFINED_MESSAGE: { id: 'common.entity.predefinedMessage', defaultMessage: 'predefined message' },

  OFFERS: { id: 'salesOffers', defaultMessage: 'Sales lists' },
  OFFER: { id: 'common.entity.offer', defaultMessage: 'sales list' },

  PARTS_OFFERS: { id: 'partsOffers', defaultMessage: 'Parts lists' },
  PARTS_OFFER: { id: 'common.entity.partsOffer', defaultMessage: 'parts list' },

  STEPS: { id: 'steps', defaultMessage: 'Steps' },
  STEP: { id: 'common.entity.step', defaultMessage: 'step' },

  TAGS: { id: 'page.config.dealer_general.tags.title', defaultMessage: 'Tags' },
  TAG: { id: 'common.entity.tag', defaultMessage: 'tag' },

  GATES: { id: 'gates', defaultMessage: 'Gates' },
  GATE: { id: 'common.entity.gate', defaultMessage: 'gate' },

  SCREENSAVERS: { id: 'page.screensaver.card', defaultMessage: 'Kiosks Screensavers' },
  SCREENSAVER: { id: 'common.entity.kioskScreensaver', defaultMessage: 'kiosk screensaver' },

  EXTRAS: { id: 'checkIn.extras', defaultMessage: 'Extras' },
  EXTRA: { id: 'common.entity.extra', defaultMessage: 'extra' },

  QUESTION_MODELS: { id: 'checkIn.questions', defaultMessage: 'Questions' },
  QUESTION_MODEL: { id: 'common.entity.questionModel', defaultMessage: 'question' },

  VEHICLE_CHECK_MODELS: { id: 'checkIn.vehicleChecks', defaultMessage: 'Vehicle checks' },
  VEHICLE_CHECK_MODEL: { id: 'common.entity.vehicleCheckModel', defaultMessage: 'vehicle check' },
} as const satisfies Record<string, MessageDescriptor>;

/** Entity id value on a create URL (e.g. `/tags/:tagId` matches both `/new` and `/<uuid>`). */
export const NEW_ENTITY_ID = 'new';

export type RouteHandle =
  | {
      crumb: MessageDescriptor;
      entityCrumb?: false;
    }
  | {
      crumb: MessageDescriptor;
      entityCrumb: true;
      entityIdParam: string;
    };

export type CrumbRoute = {
  path: string;
  handle?: RouteHandle;
};
